import React from 'react';
import { MotifIcon, MotifIconButton, MotifTooltip } from '@ey-xd/motif-react';
import { IconoirEditPencil, IconoirTrash } from '@ey-xd/motif-icon';

function renderDeleteButton(props, onDeleteClick) {
  const deleteButton = (
    <MotifIconButton
      aria-label="Delete this Security"
      type="button"
      onClick={onDeleteClick}
      data-testid="btnDeleteSecurity"
      disabled={props.data?.isCannotBeDeleted}
    >
      <MotifIcon
        iconFunction={IconoirTrash}
        size="24"
        title="Delete this Security"
      />
    </MotifIconButton>
  );

  if (props.data?.isCannotBeDeleted) {
    return (
      <MotifTooltip
        trigger={deleteButton}
        allowClick={false}
        hideCloseButton={true}
      >
        {`The Security cannot be deleted because it may have a REIT Owned Shares Value or All Shares from Issuer Value or 
    Percent of Vote within the REIT Period. The earliest period this condition exists is in ${props.data.reportPeriodDescription}.`}
      </MotifTooltip>
    );
  }
  return deleteButton;
}

function renderEditButton(props, onEditClick) {
  const editButton = (
    <MotifIconButton
      aria-label="Edit this Security"
      type="button"
      onClick={onEditClick}
      data-testid="btnEditSecurity"
    >
      <MotifIcon
        iconFunction={IconoirEditPencil}
        size="24"
        title="Edit this Security"
      />
    </MotifIconButton>
  );

  return editButton;
}
export default (props) => {
  const onEditClick = () => {
    if (props.handleEditButtonClick) {
      props.handleEditButtonClick(props.data);
    }
  };

  const onDeleteClick = () => {
    if (props.handleDeleteButtonClick) {
      props.handleDeleteButtonClick(props.data);
    }
  };

  return (
    <div>
      {props.column.colId === 'editactions' && (
        <span className="mt-2">{renderEditButton(props, onEditClick)}</span>
      )}

      {props.column.colId === 'deleteactions' && (
        <span className="mt-2">{renderDeleteButton(props, onDeleteClick)}</span>
      )}
    </div>
  );
};
